const getAuthToken = () => {
  try {
    const tokenData = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
    if (!tokenData) return null;
    try {
      const parsed = JSON.parse(tokenData);
      return parsed.access || parsed.access_token || parsed.token;
    } catch {
      // Token is a raw JWT string, not JSON
      return tokenData;
    }
  } catch (e) {
    console.error("Error retrieving auth token:", e);
  }
  return null;
};

export const createProsecutorAssignment = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/prosecutor-assignments/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create legal research request");
    }
    return response.json();
};

export const updateProsecutorAssignment = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update legal research request");
    }
    return response.json();
};

export const deleteProsecutorAssignment = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_research/prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "DELETE"
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to delete legal research request");
    }
};

